/*
 * @Author: chengyu
 * @Date: 2022-09-22 20:55:57
 * @Description: 描述
 */
import LRUCache from '@hb/map-lru-cache';
import md5 from 'md5';
import { mapApiEmitter } from './emitter';
import { isObject, isString } from './is';
import { jsonSort } from './jsonKeysSort';
import cutOffProperty from './lodash/cutOffProperty';
import { mapError, mapInfo } from './logger';
import { removeEmpty } from './transform';
/**
 * ## 计算cacheKey
 *
 * 对json数据进行排序，计算出相等的cacheKey
 *
 * ```
 * getSignature({ key1: 1, key2: 2 }) === getSignature({ key2: 2, key1: 1 })
 * ```
 * @param params
 */
export function getSignature(params) {
    try {
        // 用`removeEmpty`把`undefined`和`null`值清理一下
        var _params = jsonSort(removeEmpty(params), true);
        return md5(JSON.stringify(_params));
    }
    catch (e) {
        mapError('getSignature', e);
    }
    return undefined;
}
/**
 * 创建缓存
 */
function createCache() {
    var cache;
    // Events
    // 清空缓存
    mapApiEmitter.on('CACHE_CLEAR', function () {
        cache === null || cache === void 0 ? void 0 : cache.clear();
    });
    return function () {
        if (cache)
            return cache;
        cache = new LRUCache({
            /**
             * 最多存储10条数据
             */
            max: 10,
            /**
             * 过期时间5分钟
             */
            ttl: 5 * 60 * 1000,
        });
        return cache;
    };
}
/**
 * 初始化缓存
 */
var initCache = createCache();
/**
 * 设置缓存
 */
export function setCache(key, data) {
    try {
        if (isString(key) && isObject(data)) {
            var _data = cutOffProperty(data);
            var cache = initCache();
            cache.set(key, _data);
        }
    }
    catch (e) {
        mapError('setCache', e);
    }
}
/**
 * 获取缓存
 */
export function getCache(key) {
    try {
        if (key) {
            var cache = initCache();
            var data = cache.get(key);
            if (isObject(data)) {
                mapInfo('命中缓存(resultCache)', ['cacheKey:', key, 'result:', data]);
                return cutOffProperty(data);
            }
        }
    }
    catch (e) {
        mapError('setCache', e);
    }
    return undefined;
}
/**
 * 获取缓存信息
 * - `remainingTTL` 剩余时间
 * - `count` 存储数量
 *
 * ```
 * getCacheInfo('wtmkm3d') => { remainingTTL: 1, count: 5 }
 * ```
 */
export function getCacheInfo(key) {
    var cache = initCache();
    if (isString(key)) {
        var remainingTTL = cache.getRemainingTTL(key);
        var dump = cache.dump() || [];
        return {
            // 剩余时间
            remainingTTL: remainingTTL,
            // 存储条数
            count: dump.length,
        };
    }
    return undefined;
}
//# sourceMappingURL=data:application/json;base64,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